export default "__VITE_ASSET__191226a4__"